import { createFileRoute } from "@tanstack/react-router";
import { BusinessLanding } from "./foretag.index";

const TITLE = "Sell as a business on Sellavo – free business profile";
const DESCRIPTION =
  "Create a business profile on Sellavo, show your terms and reach buyers with a verified company page for all your listings.";

export const Route = createFileRoute("/en/businesses")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/businesses" }],
  }),
  component: BusinessLanding,
});
